export default class FiltersLookupBuilder {
  static build() {
    const res = new Map();
      res.set('Light', [
          {red: 220, green: 220, blue: 220, baseline: true, name: "Baseline"},
          {red: 236, green: 135, blue: 141, baseline: false, name: "TCI-1"},
          {red: 255, green: 159, blue: 144, baseline: false, name: "TCI-2"},
          {red: 255, green: 178, blue: 108, baseline: false, name: "TCI-3"},
          {red: 250, green: 213, blue: 152, baseline: false, name: "TCI-4"},
          {red: 197, green: 205, blue: 149, baseline: false, name: "TCI-5"},
          {red: 109, green: 155, blue: 115, baseline: false, name: "TCI-6"},
          {red: 160, green: 160, blue: 138, baseline: false, name: "TCI-7"},
          {red: 92, green: 151, blue: 141, baseline: false, name: "TCI-8"},
          {red: 119, green: 153, blue: 176, baseline: false, name: "TCI-9"},
          {red: 158, green: 167, blue: 208, baseline: false, name: "TCI-10"},
          {red: 185, green: 140, blue: 181, baseline: false, name: "TCI-11"},
          {red: 220, green: 146, blue: 183, baseline: false, name: "TCI-12"},
      ]);
      res.set('Medium', [
          {red: 169, green: 169, blue: 169, baseline: true, name: "Baseline"},
          {red: 240, green: 100, blue: 120, baseline: false, name: "TCI-13"},
          {red: 239, green: 121, blue: 77, baseline: false, name: "TCI-14"},
          {red: 255, green: 150, blue: 0, baseline: false, name: "TCI-15"},
          {red: 251, green: 204, blue: 57, baseline: false, name: "TCI-16"},
          {red: 167, green: 180, blue: 92, baseline: false, name: "TCI-17"},
          {red: 34, green: 114, blue: 67, baseline: false, name: "TCI-18"},
          {red: 0, green: 131, blue: 104, baseline: false, name: "TCI-19"},
          {red: 0, green: 114, blue: 108, baseline: false, name: "TCI-20"},
          {red: 34, green: 106, blue: 128, baseline: false, name: "TCI-21"},
          {red: 100, green: 122, blue: 172, baseline: false, name: "TCI-22"},
          {red: 172, green: 110, blue: 182, baseline: false, name: "TCI-23"},
          {red: 195, green: 102, blue: 151, baseline: false, name: "TCI-24"},
      ]);
      res.set('Dark', [
          {red: 105, green: 105, blue: 105, baseline: true, name: "Baseline"},
          {red: 26, green: 0, blue: 138, baseline: false, name: "#385 Royal Blue"},
          {red: 18, green: 54, blue: 169, baseline: false, name: "#82 Surprise Blue"},
          {red: 0, green: 78, blue: 154, baseline: false, name: "#77 Green Blue"},
          {red: 0, green: 99, blue: 192, baseline: false, name: "#81 Urban Blue"},
          {red: 178, green: 0, blue: 120, baseline: false, name: "#39 Skelton Exotic Sangria"},
          {red: 0, green: 94, blue: 203, baseline: false, name: "#68 Sky Blue"},
          {red: 168, green: 58, blue: 171, baseline: false, name: "#48 Rose Purple"},
          {red: 0, green: 111, blue: 189, baseline: false, name: "#69 Brilliant Blue"},
          {red: 68, green: 108, blue: 199, baseline: false, name: "#78 Trudy Blue"},
          {red: 106, green: 116, blue: 201, baseline: false, name: "#355 Pale Violet"},
          {red: 132, green: 108, blue: 201, baseline: false, name: "#57 Lavender"},
          {red: 139, green: 164, blue: 212, baseline: false, name: "#362 Tipton Blue"},
      ]);
    return res;
  }
}
